import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import './styles/indexTW.css';
import App from './App';
import { ErrorBoundary } from './components/shared/ErrorBoundary';

// Globale Error-Handler: Nur aktiv BEVOR React gemountet hat.
// Nach dem Mount übernimmt die React ErrorBoundary.
// Verhindert, dass harmlose async Fehler (z.B. fehlgeschlagene API-Calls,
// IntersectionObserver-Fehler) die gesamte App verstecken.
let reactMounted = false;

const showErrorFallback = (error: Error) => {
  if (reactMounted) return; // React ErrorBoundary ist zuständig
  console.error('React App konnte nicht starten:', error);
  const fallback = document.getElementById('error-fallback');
  const root = document.getElementById('root');

  if (fallback && root) {
    fallback.style.display = 'flex';
    root.style.display = 'none';
  }
};

window.addEventListener('error', (event) => {
  showErrorFallback(event.error);
});

window.addEventListener('unhandledrejection', (event) => {
  showErrorFallback(new Error(event.reason));
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <HelmetProvider>
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </HelmetProvider>
  </React.StrictMode>
);

reactMounted = true;

// Service Worker registrieren (für Premium-Support-Push-Notifications).
// Best-Effort: bei Fehler einfach loggen — die App funktioniert weiter,
// nur Push-Benachrichtigungen wären nicht möglich.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js', { scope: '/' }).catch((err) => {
      console.warn('[SW] Registrierung fehlgeschlagen:', err);
    });
  });
}

// Performance monitoring
// Debug-Ausgaben deaktiviert